import { render } from "./DashboardStatusDetailModal.vue?vue&type=template&id=4f058958&scoped=true"
import script from "./DashboardStatusDetailModal.vue?vue&type=script&lang=js"
export * from "./DashboardStatusDetailModal.vue?vue&type=script&lang=js"

import "./DashboardStatusDetailModal.vue?vue&type=style&index=0&id=4f058958&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f058958"]])

export default __exports__